import { HttpPromiseWithEntireResponse } from "@shared/svelte/Modules/ApiService";
import { get } from "svelte/store";
import RetailerUserAuthenticationsStore from "@retailer/svelte/stores/RetailerUserAuthenticationsStore";
import { RetailerUserAuthenticationStoreNotifier } from "@retailer/svelte/stores/RetailerUserAuthenticationsStore";
import cart from "@modern/services/cart";
import StagedRolloutStore from "@shared/svelte/Stores/StagedRolloutStore";

import CurrentRetailerStore from "@retailer/svelte/stores/CurrentRetailerStore";
import { default as authServices } from "@shared/services/retailer_user_authentication/index";

let refetchCount = 0;

let retailerUserAuthenticationRefreshTimer;

export const getControlStateAuthenticationService = () => {
  return authServices.find(service => service.state === get(CurrentRetailerStore)?.state);
};

const queueDelayedUpdate = () => {
  let rollouts = get(StagedRolloutStore);
  let hasRollout = rollouts?.["marketplace__retailer_user_authentication"];
  if (!hasRollout) {
    return;
  }
  retailerUserAuthenticationRefreshTimer = setTimeout(
    async () => {
      await loadRetailerUserAuthentications(true);
      if (get(RetailerUserAuthenticationStoreNotifier)) {
        queueDelayedUpdate();
      } else {
        retailerUserAuthenticationRefreshTimer = null;
      }
    },
    15 * 60 * 1000,
  );
};

// TODO this needs to unsubscribe somehow
RetailerUserAuthenticationStoreNotifier.subscribe(subscribeStatus => {
  if (subscribeStatus && !retailerUserAuthenticationRefreshTimer) {
    queueDelayedUpdate();
  }
});

const getRetailerUserAuthentications = async () => {
  return HttpPromiseWithEntireResponse({
    method: "GET",
    url: "/api/retailer/retailer_user_authentications",
  });
};

export const createRetailerUserAuthentication = async (
  distributorId: number,
  email: string,
  apiKey: string,
): Promise<any> => {
  return HttpPromiseWithEntireResponse({
    method: "POST",
    url: "/api/retailer/retailer_user_authentications",
    data: {
      retailer_user_authentication: {
        api_key: apiKey,
        distributor_id: distributorId,
        email,
      },
    },
  });
};

export const loadRetailerUserAuthentications = async (reload: boolean = false) => {
  if (reload) {
    await HttpPromiseWithEntireResponse({
      method: "POST",
      url: "/api/retailer/retailer_user_authentications/reload",
    });
  }
  const res = await getRetailerUserAuthentications();
  const retailerUserAuthentications = await res.json();

  let previousStatuses = get(RetailerUserAuthenticationsStore)
    .map(n => n.status)
    .sort();
  let needsRefetch = retailerUserAuthentications.some(n => n.updating);

  RetailerUserAuthenticationsStore.set(retailerUserAuthentications);

  let newStatuses = retailerUserAuthentications.map(n => n.status).sort();
  if (
    JSON.stringify(newStatuses) != JSON.stringify(previousStatuses) &&
    window.location.pathname == "/cart"
  ) {
    await cart.initialize();
  }

  if (needsRefetch && refetchCount < 25) {
    refetchCount++;
    return new Promise(resolve => {
      setTimeout(function () {
        resolve(loadRetailerUserAuthentications());
      }, 1500);
    });
  } else {
    refetchCount = 0;
  }

  return retailerUserAuthentications;
};
